import LogoSourceImage from "img/Logo@2x.png";
import { switchTo } from "nav-links";
import React from "react";
import styled from "styled-components";
import useBreakpoint from "use-breakpoint";
import { BREAKPOINTS, mobileBreakpointMediaQuery } from "utils";

const Link = styled.button({
  background: "none",
  border: "none",
  color: "#fff",
  fontWeight: 500,
  fontSize: 15,
  fontFamily: `"Montserrat", sans-serif`,
  marginLeft: 32,
  transition: "0.125s",
  cursor: "pointer",
  textTransform: "uppercase",
  ":hover": {
    color: "#231f20",
    fill: "#231f20",
  },
  [mobileBreakpointMediaQuery]: {
    marginLeft: 0,
    padding: 0,
    fontSize: 35,
    marginBottom: 0,
    height: 35,
  },
});

export const Logo = () => (
  <Link onClick={() => switchTo("ceremony", true)}>
    <LogoImage />
  </Link>
);

export const LogoImage = () => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS, "desktop");
  return (
    <img
      src={LogoSourceImage}
      width={breakpoint === "mobile" ? 117 : 168}
      height={breakpoint === "mobile" ? 35 : 50}
      alt="Norrtälje Dance Challenge"
    />
  );
};
